import { Injectable, computed, signal } from '@angular/core';

type VoltarHandler = () => boolean;

interface RegistroVoltar {
  id: number;
  handler: VoltarHandler;
}

@Injectable({
  providedIn: 'root',
})
export class BotaoVoltarContextService {
  private readonly registros = signal<RegistroVoltar[]>([]);
  private proximoId = 1;

  readonly visivel = computed(() => this.registros().length > 0);

  registrar(handler: VoltarHandler): () => void {
    const id = this.proximoId++;
    this.registros.update((registros) => [...registros, { id, handler }]);

    return () => {
      this.registros.update((registros) => registros.filter((registro) => registro.id !== id));
    };
  }

  solicitarVoltar(): boolean {
    const registros = [...this.registros()].reverse();

    for (const registro of registros) {
      if (registro.handler()) {
        return true;
      }
    }

    return false;
  }
}
